import omitBy from 'lodash.omitby';
import cloneDeep from 'lodash.clonedeep';
import isNil from 'lodash.isnil';
import { EricssonNeTargetTemplateFormSection } from 'routes/TargetDeliveryTemplateAccessFunction/TargetDeliveryTemplateAccessFunction.types';
import {
  TargetDeliveryTemplateAccessFunction,
  TargetDeliveryTemplateAccessFunctionFormData,
  TargetDeliveryTemplateInterfaceFormData,
  TargetDeliveryTemplateSection,
} from './targetDeliveryTemplateAccessFunction.types';

// eslint-disable-next-line import/prefer-default-export
export function adaptToCreate(
  data: TargetDeliveryTemplateAccessFunction,
): TargetDeliveryTemplateAccessFunction {
  return data;
}

export function adaptTargetDeliveryTemplatesMap(
  data: TargetDeliveryTemplateAccessFunction[],
):{ [key: string]: TargetDeliveryTemplateAccessFunction } {

  return data
    .reduce((total, template) => ({
      ...total,
      [template.id as string]: adaptToForm(template),
    }), {});
}

export const getTemplateOptions = (
  templates: TargetDeliveryTemplateAccessFunction[],
  afTag: string,
): { label: string, value: string }[] => {

  return templates
    .filter((temp) => temp.afType === afTag)
    .map((temp) => ({
      label: temp.name as string,
      value: temp.id as string,
    }));
};

export function adaptToForm(
  targetDeliveryTemplate: TargetDeliveryTemplateAccessFunction,
): TargetDeliveryTemplateAccessFunctionFormData {

  const clonedTargetTemplate = cloneDeep(targetDeliveryTemplate);

  const targetDeliveryTemplateForm: TargetDeliveryTemplateAccessFunctionFormData = {
    ...clonedTargetTemplate,
    targetInformation: adaptTargetSectionToForm(clonedTargetTemplate, 'targetInformation'),
    callContentChannels: adaptTargetSectionToForm(clonedTargetTemplate, 'callContentChannels'),
    monitoringCenterFlags: adaptTargetSectionToForm(clonedTargetTemplate, 'monitoringCenterFlags'),
    ICD: adaptTargetSectionToForm(clonedTargetTemplate, 'ICD'),
    networkType: adaptTargetSectionToForm(clonedTargetTemplate, 'networkType'),
    callContentType: adaptTargetSectionToForm(clonedTargetTemplate, 'callContentType'),
    EIMSMCNB: adaptTargetSectionToForm(clonedTargetTemplate, 'EIMSMCNB'),
    EIMSTARGET: adaptTargetSectionToForm(clonedTargetTemplate, 'EIMSTARGET'),
    EIMSMSCTRGT: adaptTargetSectionToForm(clonedTargetTemplate, 'EIMSMSCTRGT'),
    EIMSGPRSTRGT: adaptTargetSectionToForm(clonedTargetTemplate, 'EIMSGPRSTRGT'),
    EIMSWRLNTRGT: adaptTargetSectionToForm(clonedTargetTemplate, 'EIMSWRLNTRGT'),
    EIMSGENERAL: adaptTargetSectionToForm(clonedTargetTemplate, 'EIMSGENERAL'),
    EIMSMC: adaptTargetSectionToForm(clonedTargetTemplate, 'EIMSMC'),
    usnbdTargetInformation: adaptTargetSectionToForm(clonedTargetTemplate, 'usnbdTargetInformation'),
    usnbdCallContentChannelInformation: adaptTargetSectionToForm(clonedTargetTemplate, 'usnbdCallContentChannelInformation'),
  };

  return omitBy<TargetDeliveryTemplateAccessFunctionFormData>(
    targetDeliveryTemplateForm, isNil,
  ) as TargetDeliveryTemplateAccessFunctionFormData;

}

function adaptTargetSectionToForm(
  targetDeliveryTemplate: TargetDeliveryTemplateAccessFunction,
  sectionName: 'targetInformation' | 'callContentChannels' | 'monitoringCenterFlags' | 'ICD' | 'networkType' | 'callContentType' | 'monitoringCenterNumberInformation' | EricssonNeTargetTemplateFormSection | 'usnbdTargetInformation' | 'usnbdCallContentChannelInformation',
): TargetDeliveryTemplateInterfaceFormData[] | undefined {

  if (targetDeliveryTemplate.templateSections == null) {
    return undefined;
  }

  const sections = targetDeliveryTemplate.templateSections.filter(
    (section) => section.name === sectionName,
  );

  return sections.map(adaptOptionsToFields);
}

function adaptOptionsToFields(
  section: TargetDeliveryTemplateSection,
):TargetDeliveryTemplateInterfaceFormData {

  const targetSectionOption = (section.options || []).reduce((total, option) => ({
    ...total,
    [option.key]: option.value,
  }), {}) as TargetDeliveryTemplateInterfaceFormData;

  return {
    ...targetSectionOption,
    id: section.id as string,
  };
}
